module.exports = __webpack_public_path__ + "img/logo_simepox.4663962b.png";